// extracted by mini-css-extract-plugin
module.exports = {"steps":"Steps_steps__2qV0H","item":"Steps_item__qLlDJ","item_active":"Steps_item_active__3uW1A","item__circle":"Steps_item__circle__3T3E6","item__label":"Steps_item__label__3NSBb"};